import { BaseAppComponent } from '@core/components/base-app/base-app.component';
import { ApplicationRef, Component, inject } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [TranslateModule, RouterOutlet],
  templateUrl: './app.component.html',
  providers: [TranslateService],
})
export class AppComponent {
  private appRef = inject(ApplicationRef);

  private bootstrapApplication(): void {
    const app = BaseAppComponent;
    this.appRef.bootstrap(app, document.getElementById('app'));
  }
}
